import React, { useState } from 'react';
import Icon from '../../../common/Icon';
import MetadataViewer from '../../../metadata/MetadataViewer';
import CalendarEventViewer from '../../../metadata/CalendarEventViewer';
import { associatedMetadata } from '../../constants/submissionShow';
import { sortByAlpha, sortable } from '../../../../helpers/sorters';

const RadioValue = ({
  field,
  response,
  isEditing,
  adminField,
  handleResponseOptionUpdate,
  displayAdminQuotas,
}) => {
  const [viewMeta, setViewMeta] = useState(false);
  const [viewEvent, setViewEvent] = useState(false);
  const alphaSorted = field.alpha || false;
  const width =
    field.width === 1 ? 'full' : field.width === 2 ? 'half' : 'third';

  const sortedFieldOptions = alphaSorted
    ? sortByAlpha(field.options, 'value')
    : sortable(field.options);

  const responseOption = response
    ? sortedFieldOptions.find((opt) =>
        response.response_options.map((ro) => ro.option_id).includes(opt.id)
      )
    : null;

  const optWithQuotaCounts = (option) => {
    return `${option.name} - (${option.response_options_count}/${option.local_quota})${option.hidden ? ' - Hidden from public' : ''}`;
  };

  return (
    <div className={'input-group ' + width}>
      <label
        className={responseOption || isEditing || adminField ? '' : 'empty'}
      >
        {field.name + ': '}
      </label>
      {adminField && field.help_text && (
        <p className='admin-help-text'>{field.help_text}</p>
      )}
      {isEditing || adminField ? (
        <>
          {associatedMetadata(field.metadata_entries, responseOption).length >
            0 && (
            <>
              <Icon
                icon='tag'
                title='View Metadata'
                onClick={() => setViewMeta(true)}
              />
              <MetadataViewer
                viewMeta={viewMeta}
                setViewMeta={setViewMeta}
                metadata={associatedMetadata(
                  field.metadata_entries,
                  responseOption
                )}
                displayValue={responseOption ? responseOption.value : ''}
              />
            </>
          )}
          {responseOption?.calendar_event && (
            <>
              <Icon
                icon='calendar-check'
                title='View Calendar Event'
                onClick={() => setViewEvent(true)}
                faPrefix={'regular'}
              />
              <CalendarEventViewer
                viewEvent={viewEvent}
                setViewEvent={setViewEvent}
                calendarEvent={responseOption.calendar_event}
                displayValue={responseOption?.value || ''}
              />
            </>
          )}
          <div className='radio-input'>
            {sortedFieldOptions.map((opt) => {
              return (
                <div key={opt.id} className='radio-group'>
                  <input
                    id={opt.id}
                    type='radio'
                    checked={
                      responseOption ? responseOption.id === opt.id : false
                    }
                    onChange={(e) =>
                      handleResponseOptionUpdate(e, response, opt.id)
                    }
                  />
                  <label htmlFor={opt.id}>
                    {field.informs_global || displayAdminQuotas
                      ? optWithQuotaCounts(opt)
                      : opt.name}
                  </label>
                </div>
              );
            })}
          </div>
        </>
      ) : responseOption ? (
        responseOption.value
      ) : (
        ''
      )}
    </div>
  );
};

export default RadioValue;
